import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import useDetailStyles from '../detail-styles'
import { resolveYoutubeMediaId } from '../lib/resolve-youtube-media-id'

const DetailYoutubeEmbed = ({ embedId }) => {
  const classes = useDetailStyles()
  const mediaId = resolveYoutubeMediaId(embedId)

  if (!mediaId) {
    return null
  }

  return (
    <Box className={classes.detailVideo}>
      <iframe
        src={`https://www.youtube.com/embed/${mediaId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </Box>
  )
}

DetailYoutubeEmbed.propTypes = {
  embedId: PropTypes.string,
}

export default DetailYoutubeEmbed
